import React, { ComponentType } from "react";
import serviceWorldCaseItemStyle from "./serviceWorldCaseItemStyle";
import { ListItemButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router";
import { getProductData } from "../../../services/productService";
import Typography from "@mui/material/Typography";
import IconWrapper from "../../IconWrapper/IconWrapper";
import { translate } from "../../../services/translations/translations";
import { MinimalCase } from "../../../types/Entities/MinimalCase";

type ServiceWorldCaseItemProps = {
  minimalCase: MinimalCase;
  withDivider?: boolean;
  NotificationComponent?: ComponentType<{ minimalCase: MinimalCase }> | null;
  listItemButtonConfig?: { getLink?: Function; getIsSelected?: Function; handleClick?: Function };
};

const ServiceWorldCaseItem = ({ minimalCase, withDivider = true, listItemButtonConfig = {}, NotificationComponent = null }: ServiceWorldCaseItemProps) => {
  const isLink = !!listItemButtonConfig.getLink;

  let conditionalProps: ConditionalConfig = {};

  if (isLink && listItemButtonConfig?.getLink) {
    conditionalProps.component = Link;
    conditionalProps.to = listItemButtonConfig.getLink(minimalCase);
  }

  if (!!listItemButtonConfig.getIsSelected) {
    conditionalProps.selected = listItemButtonConfig.getIsSelected(minimalCase);
  }

  if (!!listItemButtonConfig.handleClick) {
    conditionalProps.onClick = () => listItemButtonConfig.handleClick?.(minimalCase);
  }

  return (
    <>
      <ListItemButton {...conditionalProps} sx={[serviceWorldCaseItemStyle.caseItem, withDivider && serviceWorldCaseItemStyle.caseItemWithDivider]}>
        <Typography sx={serviceWorldCaseItemStyle.reference}>{minimalCase.reference}</Typography>
        <Grid
          container
          wrap={"nowrap"}
          sx={[{
            alignItems: "center"
          }, serviceWorldCaseItemStyle.innerContainer]}>
          <Grid>
            <IconWrapper icon={getProductData(minimalCase.name, "productCategory.icon")} sx={serviceWorldCaseItemStyle.icon} alt={"Produkt Icon"} />
          </Grid>
          <Grid sx={serviceWorldCaseItemStyle.textContainer}>
            <Typography variant={"h6"}>
              {getProductData(minimalCase.name, "productCategory.label")}
              {minimalCase.productCategory === "administrativeLaw" &&
                minimalCase.administrativeCaseType !== "main" &&
                " - " + translate(`${minimalCase.name}.administrativeCaseType.${minimalCase.administrativeCaseType}.label`, minimalCase)}
              {(minimalCase.instanceLevel || 0) > 0 ? " - " + translate(minimalCase.name + ".instanceLevel", minimalCase) : null}
            </Typography>
            <Typography>
              {getProductData(minimalCase.name, "label")}
              {minimalCase.opposingParty ? ` - ${minimalCase.opposingParty}` : ""}
            </Typography>
          </Grid>
          {NotificationComponent && <NotificationComponent minimalCase={minimalCase} />}
        </Grid>
      </ListItemButton>
    </>
  );
};

type ConditionalConfig = {
  component?: typeof Link;
  to?: string;
  selected?: boolean;
  onClick?: () => void;
};

export default ServiceWorldCaseItem;
